import React, { useMemo, useRef } from "react";
import { Marker } from "react-leaflet";
// eslint-disable-next-line
function DraggableMarker({ position, setPosition }) {
  const markerRef = useRef(null)
  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current
        if (marker != null) {
          setPosition(marker.getLatLng())
        }
      },
    }),
    // eslint-disable-next-line
    [],
  )

  return (
    <Marker
      draggable={true}
      eventHandlers={eventHandlers}
      position={position}
      ref={markerRef}>
    </Marker>
  )
}

export default DraggableMarker;